import { PhitoNotificationSubscriptionType } from './PhitoNotificationSubscriptionType';
import { PhitoUserDTO } from '../../../services/phito-object';

export class PhitoNotificationSubscription {
    subscriptionTypes: PhitoNotificationSubscriptionType[] = [];
    user: PhitoUserDTO;
}
